
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/helping-the-homeless",
      function () {
        return require("private-next-pages/articles/helping-the-homeless.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/helping-the-homeless"])
      });
    }
  